import { SxProps, Theme } from '@mui/system';

export const disclaimerStyles: { [key: string]: SxProps<Theme> } = {
  standardParagraph: {
    color: '#404040',
  },
  boldParagraph: {
    color: '#404040',
    fontWeight: 'bold',
  },
  containerStyle: {
    paddingBottom: '64px',
  },
};
